<template>
  <div v-if="filterEnabled" class="px-4 filter-bar py-3 border-t uppercase tracking-wide font-bold text-gray-600 text-sm bg-gray-100">
    Filter enabled<!--: <span v-for="filter in filterList[1]" :key="filter">{{ filter }} </span>-->
    <button alt="Reset filter" class="float-right text-red-600 hover:text-red-700 uppercase font-bold text-sm tracking-wide" @click="emptyFilter">
      reset
      <!--
      <svg class="fill-current opacity-75 w-4 inline mb-1 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"/></svg>
      -->
    </button>
  </div>
</template>

<script>
export default {
  data(){
    return {
      filterEnabled: false,
      filterList: []
    }
  },
  props: {

  },
  watch: {
    
  },
  mounted() {
    this.$root.$on('doFilter', val => {
      if(val) {
        this.filterList = val 
        this.filterEnabled = true
      } else {
        this.filterList = []
        this.filterEnabled = false
      }
    })
    this.$root.$on('emptyFilter', val => {
      this.filterList = []
      this.filterEnabled = false
    })
  },
  methods: {
      emptyFilter() {
          this.$root.$emit('emptyFilter', true)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.filter-bar{
  transform: translate3d(0, 0, 0);
  transition: 0.1s all ease-out;
}

.filter-bar--hidden{
  transform: translate3d(0, -100%, 0);
}
</style>
